<div class="flex flex-column w-full h-full p-0 md:p-3 overflow-y-auto">


  <div class="flex flex-column gap-6 px-2 md:px-5">
    <!-- Intro Box -->
    <section class="surface-ground p-4 border-round border-left-3 border-orange-500 text-700 line-height-3 text-base md:text-lg">
      <p class="m-0">
        A Política de Privacidade abaixo explica como coletamos, utilizamos, armazenamos e protegemos os dados pessoais dos usuários que utilizam a plataforma <strong>Seu Ingresso Aqui</strong>, conforme a Lei Geral de Proteção de Dados (Lei nº 13.709/2018 – LGPD) e demais legislações brasileiras aplicáveis.
      </p>
    </section>

    <!-- Seção 1 -->
    <section>
      <h2 class="flex align-items-center gap-2 text-800 text-xl md:text-2xl font-bold mb-3 pb-2 border-bottom-1 surface-border">
        <i class="pi pi-info-circle text-orange-500 text-xl"></i>
        1. Introdução
      </h2>
      <div class="text-700 line-height-3">
        <p class="mb-2">A privacidade e a segurança dos seus dados são prioridades para nós.</p>
        <p class="m-0">Ao utilizar a plataforma, o usuário declara ter lido e concordado com as práticas descritas nesta Política.</p>
      </div>
    </section>

    <!-- Seção 2 -->
    <section>
      <h2 class="flex align-items-center gap-2 text-800 text-xl md:text-2xl font-bold mb-3 pb-2 border-bottom-1 surface-border">
        <i class="pi pi-database text-orange-500 text-xl"></i>
        2. Dados que Coletamos
      </h2>
      <div class="text-700 line-height-3">
        <p class="mb-3">Coletamos apenas os dados necessários para garantir o funcionamento correto dos serviços, incluindo:</p>

        <h3 class="text-800 font-semibold text-lg mb-2">2.1 Dados fornecidos diretamente pelo usuário</h3>
        <ul class="pl-4 mb-4 mt-0">
          <li class="mb-1">Nome completo</li>
          <li class="mb-1">E-mail</li>
          <li class="mb-1">CPF</li>
          <li class="mb-1">Telefone</li>
          <li class="mb-1">Endereço</li>
          <li class="mb-1">Informações de cadastro e login</li>
          <li class="mb-1">Dados necessários para emissão de ingressos e notas fiscais</li>
        </ul>

        <h3 class="text-800 font-semibold text-lg mb-2">2.2 Dados coletados automaticamente</h3>
        <ul class="pl-4 mb-4 mt-0">
          <li class="mb-1">Endereço IP</li>
          <li class="mb-1">Informações do navegador e dispositivo</li>
          <li class="mb-1">Cookies e identificadores de sessão</li>
          <li class="mb-1">Logs de acesso e ações realizadas na plataforma</li>
        </ul>

        <h3 class="text-800 font-semibold text-lg mb-2">2.3 Dados financeiros</h3>
        <p class="mb-2">Não armazenamos dados completos de cartão de crédito.</p>
        <p class="m-0">As transações são processadas por intermediadores de pagamento certificados (por exemplo: Mercado Pago, Pagar.me, Stripe), conforme regras PCI-DSS.</p>
      </div>
    </section>

    <!-- Seção 3 -->
    <section>
      <h2 class="flex align-items-center gap-2 text-800 text-xl md:text-2xl font-bold mb-3 pb-2 border-bottom-1 surface-border">
        <i class="pi pi-check-circle text-orange-500 text-xl"></i>
        3. Finalidades do Uso dos Dados
      </h2>
      <div class="text-700 line-height-3">
        <p class="mb-3">Os dados coletados são utilizados para:</p>
        <ul class="pl-4 m-0">
          <li class="mb-1">Realizar e confirmar compras de ingressos</li>
          <li class="mb-1">Emitir ingressos, QR Codes e comprovantes</li>
          <li class="mb-1">Controlar acesso e check-in no evento</li>
          <li class="mb-1">Emitir notas fiscais</li>
          <li class="mb-1">Prevenir fraudes e garantir segurança</li>
          <li class="mb-1">Cumprir obrigações legais</li>
          <li class="mb-1">Enviar e-mails transacionais (compra, cancelamento, suporte)</li>
          <li class="mb-1">Permitir contato entre organização do evento e compradores</li>
        </ul>
      </div>
    </section>

    <!-- Seção 4 -->
    <section>
      <h2 class="flex align-items-center gap-2 text-800 text-xl md:text-2xl font-bold mb-3 pb-2 border-bottom-1 surface-border">
        <i class="pi pi-share-alt text-orange-500 text-xl"></i>
        4. Compartilhamento de Dados
      </h2>
      <div class="text-700 line-height-3">
        <p class="mb-3">Compartilhamos informações somente quando necessário, e sempre de forma segura:</p>

        <div class="mb-3">
          <h3 class="text-800 font-semibold text-lg m-0 mb-1">4.1 Com produtores de eventos</h3>
          <p class="m-0">Para identificação de participantes, controle de acesso e atendimento no local.</p>
        </div>

        <div class="mb-3">
          <h3 class="text-800 font-semibold text-lg m-0 mb-1">4.2 Com intermediadores de pagamento</h3>
          <p class="m-0">Para análise antifraude, autorização e liquidação financeira.</p>
        </div>

        <div class="mb-3">
          <h3 class="text-800 font-semibold text-lg m-0 mb-1">4.3 Com autoridades públicas</h3>
          <p class="m-0">Quando houver determinação legal, ordem judicial ou obrigação regulatória.</p>
        </div>

        <div class="mb-4">
          <h3 class="text-800 font-semibold text-lg m-0 mb-1">4.4 Com fornecedores de tecnologia</h3>
          <p class="m-0">Serviços de hospedagem, e-mail, SMS, armazenamento e monitoramento de segurança.</p>
        </div>

        <div class="surface-ground p-3 border-round border-left-3 border-orange-500">
          <strong class="text-orange-700">Não vendemos dados pessoais a terceiros.</strong>
        </div>
      </div>
    </section>

    <!-- Seção 5 -->
    <section>
      <h2 class="flex align-items-center gap-2 text-800 text-xl md:text-2xl font-bold mb-3 pb-2 border-bottom-1 surface-border">
        <i class="pi pi-globe text-orange-500 text-xl"></i>
        5. Cookies e Tecnologias de Rastreamento
      </h2>
      <div class="text-700 line-height-3">
        <p class="mb-3">Utilizamos cookies para:</p>
        <ul class="pl-4 mb-3 mt-0">
          <li class="mb-1">Autenticação e manutenção de login</li>
          <li class="mb-1">Personalização da experiência</li>
          <li class="mb-1">Análise de navegação e melhoria da plataforma</li>
          <li class="mb-1">Segurança da conta</li>
        </ul>
        <p class="m-0">O usuário pode desativar cookies no navegador, porém certas funcionalidades podem ser afetadas.</p>
      </div>
    </section>

    <!-- Seção 6 -->
    <section>
      <h2 class="flex align-items-center gap-2 text-800 text-xl md:text-2xl font-bold mb-3 pb-2 border-bottom-1 surface-border">
        <i class="pi pi-shield text-orange-500 text-xl"></i>
        6. Armazenamento e Proteção dos Dados
      </h2>
      <div class="text-700 line-height-3">
        <p class="mb-3">Aplicamos medidas de segurança técnicas e administrativas para proteger as informações:</p>
        <ul class="pl-4 mb-3 mt-0">
          <li class="mb-1">Criptografia em trânsito (HTTPS/SSL)</li>
          <li class="mb-1">Armazenamento seguro em servidores certificados</li>
          <li class="mb-1">Controle de acesso e autenticação reforçada</li>
          <li class="mb-1">Monitoramento contínuo contra tentativas de fraude</li>
          <li class="mb-1">Backup periódico e logs de auditoria</li>
        </ul>
        <p class="m-0">Os dados são mantidos apenas pelo tempo necessário para cumprir as finalidades descritas nesta Política ou obrigações legais.</p>
      </div>
    </section>

    <!-- Seção 7 -->
    <section>
      <h2 class="flex align-items-center gap-2 text-800 text-xl md:text-2xl font-bold mb-3 pb-2 border-bottom-1 surface-border">
        <i class="pi pi-user text-orange-500 text-xl"></i>
        7. Direitos do Usuário (LGPD)
      </h2>
      <div class="text-700 line-height-3">
        <p class="mb-3">O titular dos dados pode, a qualquer momento:</p>
        <ul class="pl-4 mb-3 mt-0">
          <li class="mb-1">Confirmar a existência de tratamento</li>
          <li class="mb-1">Solicitar acesso aos seus dados</li>
          <li class="mb-1">Corrigir informações incompletas ou desatualizadas</li>
          <li class="mb-1">Solicitar anonimização, bloqueio ou eliminação</li>
          <li class="mb-1">Revogar consentimento</li>
          <li class="mb-1">Solicitar portabilidade</li>
          <li class="mb-1">Contestar tratamentos indevidos</li>
        </ul>
        <p class="m-0">Pedidos devem ser enviados ao e-mail de privacidade disponibilizado no sistema.</p>
      </div>
    </section>

    <!-- Seção 8 -->
    <section>
      <h2 class="flex align-items-center gap-2 text-800 text-xl md:text-2xl font-bold mb-3 pb-2 border-bottom-1 surface-border">
        <i class="pi pi-envelope text-orange-500 text-xl"></i>
        8. Comunicações e Contato
      </h2>
      <div class="text-700 line-height-3">
        <p class="mb-3">Podemos enviar:</p>
        <ul class="pl-4 mb-3 mt-0">
          <li class="mb-1">E-mails sobre pedidos e ingressos</li>
          <li class="mb-1">Avisos de atualização de política</li>
          <li class="mb-1">Informações operacionais do evento adquirido</li>
        </ul>
        <strong class="text-700">Não enviamos marketing sem consentimento.</strong>
      </div>
    </section>

    <!-- Seção 9 -->
    <section>
      <h2 class="flex align-items-center gap-2 text-800 text-xl md:text-2xl font-bold mb-3 pb-2 border-bottom-1 surface-border">
        <i class="pi pi-refresh text-orange-500 text-xl"></i>
        9. Alterações na Política
      </h2>
      <div class="text-700 line-height-3">
        <p class="mb-2">Esta Política pode ser atualizada para refletir melhorias técnicas, exigências legais ou mudanças nos serviços.</p>
        <p class="m-0">A versão mais recente estará sempre disponível no site.</p>
      </div>
    </section>

    <!-- Seção 10 -->
    <section>
      <h2 class="flex align-items-center gap-2 text-800 text-xl md:text-2xl font-bold mb-3 pb-2 border-bottom-1 surface-border">
        <i class="pi pi-id-card text-orange-500 text-xl"></i>
        10. Encarregado de Dados (DPO)
      </h2>
      <p class="text-700 line-height-3 m-0">O responsável pelo tratamento de dados pessoais pode ser contatado por meio do e-mail listado na área de suporte da plataforma.</p>
    </section>

    <!-- Seção 11 -->
    <section>
      <h2 class="flex align-items-center gap-2 text-800 text-xl md:text-2xl font-bold mb-3 pb-2 border-bottom-1 surface-border">
        <i class="pi pi-file text-orange-500 text-xl"></i>
        11. Disposições Finais
      </h2>
      <div class="text-700 line-height-3">
        <p class="mb-2">Ao continuar utilizando a plataforma, o usuário aceita os termos desta Política.</p>
        <p class="m-0">Caso não concorde, pode solicitar esclarecimentos ou encerrar seu cadastro.</p>
      </div>
    </section>

    <!-- Footer -->
    <div class="text-center text-500 text-sm mt-6 pt-4 border-top-1 surface-border">
      <p class="mb-1"><strong>Última atualização:</strong> Dezembro de 2025</p>
      <p class="m-0"><strong>Seu Ingresso Aqui</strong> - Todos os direitos reservados</p>
    </div>
  </div>
</div>
